<p500-ui-many-items [data]="data" [title]="'Goal Types'" [tmpl]="tmpl" [previewTmpl]="previewTmpl"></p500-ui-many-items>
<ng-template let-data="data" #previewTmpl>
  <gtd-ui-field-default-string-or-empty [data]="goalTypes[data]"></gtd-ui-field-default-string-or-empty>
</ng-template>
<ng-template let-data="data" #tmpl>
  <span class="font-headline-5">
    <gtd-ui-field-default-string-or-empty [data]="goalTypes[data]"></gtd-ui-field-default-string-or-empty>
  </span>
</ng-template>
